import { useEffect, useState } from "react";

import axios from "axios";
import CardPlano from "../CardPlano";
import { Combo } from "../Combo";
import config from "./../../config";

export const Planos = () => {
  const [composicaoPlanos, setComposicaoPlanos] = useState([]);
  const [planos, setPlanos] = useState([]);

  const getComposicaoPlanos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "composicaoPlanos/listar"
      );
      if (response.data.status !== "sucesso") {
        console.error("Erro ao buscar dados:", response.data.mensagem);
      } else {
        setComposicaoPlanos((state) => [...state, ...response.data.dados]);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };

  const getplanos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "planos/listar"
      );
      if (response.data.status !== "sucesso") {
        console.error("Erro ao buscar dados:", response.data.mensagem);
      } else {
        setPlanos((state) => [...state, ...response.data.dados]);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };

  useEffect(() => {
    /**BUSCANO COMPOSICAO DOS PLANOS */
    getComposicaoPlanos();

    /**BUSCANDO PLANOS */
    getplanos();
  }, []);

  return (
    <section id="combos-home" className="planos-home">
      <svg
        id="svg-topo-planos"
        data-name="svg-topo-planos"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 236.77"
      >
        <defs>
          <clipPath id="clip-path">
            <rect className="cls-1" y="-95.19" width="1920" height="332"></rect>
          </clipPath>
        </defs>

        <g className="cls-2" fill="#002626" stroke="none">
          <path d="M1920,1446.1s-850.57,145.71-1021.19,145.71C730.93,1591.81,0,1446.1,0,1446.1V170.39S970.76-27.27,1197.74,4.18C1330.16,22.53,1920,170.39,1920,170.39Z"></path>
        </g>
      </svg>

      <div className="container-beneficios">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className="color-red text-center">Benefícios</h2>
              <h3 className="color-white text-center">
                As vantagens do {config.NOME_FANTASIA} são muitas!
              </h3>
            </div>
          </div>

          {/* BLOCO DE PLANOS */}
          <div className="wrap-planos">
            {planos.map((plano) => (
              <Combo dadosPlano={plano} />
            ))}
            {/* BENEFICIOS DE TITULAR */}
            {/*<div className="bloco container-plano-titular">
              <div className="wrap-beneficios-planos">
                <div className="title-plano title-titular">
                  <span>Titular</span>
                  <span>R$44,90/por mês</span>
                </div>

                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-tela-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Telemedicina - 24h Mais de 38 especialidades</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-coracao.svg"
                    alt="Tela Titular"
                  />
                  <span>
                    Assistência Funeral Familiar - Titular + Cônjuge + Filhos
                    até 21 anos
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-seguro-titular.png"
                    alt="Tela Titular"
                  />
                  <span>
                    Seguro Morte Acidental Titular - Cobertura R$ 20.000,00
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-seguro-titular.png"
                    alt="Tela Titular"
                  />
                  <span>
                    Seguro Morte Acidental Filhos (14 a 21 anos) R$ 10.000,00
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-seguro-titular.png"
                    alt="Tela Titular"
                  />
                  <span>
                    Invalidez por acidente Titular Cobertura R$ 10.000,00
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-casa-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Assistência Residêncial</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-presente-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Sorteio Mensal R$ 20.000,00</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-psicologo-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Psicólogo</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-nutricionista-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Nutricionista</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-medicamento-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Desconto em medicamentos</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-cruz-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Clube de Vantagens</span>
                </div>
                <div className="beneficio-plano beneficio-plano-titular">
                  <img
                    src="/imagens/beneficios-planos/icon-cursos-titular.png"
                    alt="Tela Titular"
                  />
                  <span>Mais de 330 cursos livres grátis</span>
                </div>
              </div>
            </div>
            {/* BENEFICIOS DE DEPENDENTES */}
            {/*<div className="bloco container-plano-dependentes">
              <div className="wrap-beneficios-planos">
                <div className="title-plano title-dependentes">
                  <span>Dependentes</span>
                  <span>R$34,90/por mês</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-tela-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Telemedicina - 24h Mais de 38 especialidades</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-seguro-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>
                    Seguro Morte Acidental Cobertura pela apólice do titular
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-seguro-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>
                    Assistência Funeral Cobertura pela apólice Titular
                  </span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-psicologo-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Psicólogo</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-nutricionista-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Nutricionista</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-medicamento-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Desconto em medicamentos</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-cruz-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Clube de Vantagens *</span>
                </div>
                <div className="beneficio-plano beneficio-plano-dependente">
                  <img
                    src="/imagens/beneficios-planos/icon-cursos-dependente.png"
                    alt="Tela Titular"
                  />
                  <span>Mais de 330 cursos livres grátis</span>
                </div>
              </div>
            </div>
            */}
            {/* BLOCO DE ESCOLHER PLANOS */}
            <div
              id="container-plano-select"
              className="row container-plano-select"
            >
              {composicaoPlanos.map((composicao) => (
                <CardPlano
                  tituloComposicao={composicao.descricao_composicao}
                  valorComposicao={composicao.valor_total}
                  idComposicao={composicao.id}
                  idPlanoGetnet={composicao.id_plano_getnet}
                  qtdeDependentes={composicao.qtde_dependentes}
                  key={composicao.id}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 1280.000000 158.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,158.000000) scale(0.100000,-0.100000)"
          fill="#002626"
          stroke="none"
        >
          <path
            d="M0 1356 c0 -205 2 -225 17 -230 39 -11 1343 -331 1738 -426 1437
                    -346 2494 -583 2946 -660 64 -10 174 -24 244 -30 861 -70 3181 236 6460 851
                    326 61 1260 242 1347 260 l48 11 0 224 0 224 -6400 0 -6400 0 0 -224z"
          ></path>
        </g>
      </svg>
    </section>
  );
};
